import React, { Fragment, memo, useState } from 'react'
import { AppInput, Label } from '../../components'
import DatePicker from 'react-datepicker'
import { connect } from 'react-redux'
import moment from 'moment'

const Date = ({
                id,
                style,
                helpText,
                name,
                label,
                value,
                onChange,
                settings,
                unlabeled,
                context,
              }) => {
  const [strVal, setStrVal] = useState('')

  if (unlabeled) {
    helpText = null
    label = null
  }

  const strToDate = str => {
    let dateVal
    if (typeof str === 'string') {
      if (str === '') {
        dateVal = null
      } else {
        dateVal = moment(str).toDate()
        // console.log(`${dateVal.toString()}  (${dateVal.toUTCString()})`)
      }
    }
    return dateVal
  }

  const changeStr = str => {
    if (!context.mutable) return
    const dateVal = strToDate(str)
    const overFlow = dateVal && dateVal.getFullYear() > 9999
    if (overFlow) {
      setStrVal('')
    } else {
      if (!str || dateVal) {
        // retain string value for editing continuity
        setStrVal(str)
      }
      onChange(dateVal)
    }
  }

  switch (style) {
    case 'textbox':
      return (
        <AppInput key={id} helpText={helpText} id={id} name={name} label={label}
                  value={strVal || (value ? moment(value).format('YYYY-MM-DD') : '') || ''}
                  onChange={val => changeStr(val)}
                  type={'date'}/>
      )

    case 'datepicker':
      return (
        <Fragment>
          <Label name={name} helpText={helpText} label={label} forId={id}/><br/>
          <DatePicker key={id} id={id}
                      selected={value ? moment(value).toDate() : null || null}
                      className={'form-control rounded-2 w-100'}
                      locale={settings.locale}
                      dateFormat={'P'} /* short localized date */
                      onChange={val => onChange(val)}
                      popperModifiers={{
                        preventOverflow: {},
                      }}
          />
        </Fragment>
      )

    default:
      return null
  }
}

const mapStateToProps = state => {
  const { settings } = state
  return {
    settings,
  }
}
export default memo(connect(mapStateToProps)(Date))
